import { createFileRoute } from '@tanstack/react-router'
import { WorkspaceRouteShell } from '@/components/app/route-shells'
import { BillingTab } from '@/components/settings/tabs/billing-tab'
import type { RouteStaticData } from '@/lib/router/breadcrumbs'

export const Route = createFileRoute('/_app/billing')({
  component: BillingPage,
  staticData: {
    breadcrumbs: [{ label: 'Billing', href: '/billing' }],
  } satisfies RouteStaticData,
})

function BillingPage() {
  return (
    <WorkspaceRouteShell>
      <BillingTab />
    </WorkspaceRouteShell>
  )
}
